import { CheckOutlined } from "@ant-design/icons";
import { Empty, Input, Tooltip, Typography } from "antd";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { DATASET_GROUPS } from "@/warRoom/datasets/registry";
import {
  useGraphStore,
  useVisibleDatasets,
} from "@/warRoom/store/useGraphStore";

const { Text } = Typography;

/**
 * 第 ① 步：挑一份資料 —— 決定「接下來拖進畫布的圖」看哪份資料。
 * 這裡不做任何篩選，圖型是下一步才依這份資料決定的；
 * 要換畫布上某張圖的資料，在第 ③ 步（那張圖自己的面板）換，不是在這裡。
 */
export default function DataPanel() {
  const { t } = useTranslation();
  const activeDatasetKey = useGraphStore((s) => s.activeDatasetKey);
  const pickDataset = useGraphStore((s) => s.pickDataset);
  const datasets = useVisibleDatasets();
  const [q, setQ] = useState("");

  const groups = useMemo(() => {
    const keyword = q.trim().toLowerCase();
    return DATASET_GROUPS.map((group) => {
      const items = datasets
        .filter((d) => d.group === group)
        .filter((d) => {
          if (!keyword) return true;
          return (
            d.label.toLowerCase().includes(keyword) ||
            d.description.toLowerCase().includes(keyword) ||
            d.fields.some((f) => f.label.toLowerCase().includes(keyword))
          );
        });
      return { group, items };
    }).filter((g) => g.items.length > 0);
  }, [q, datasets]);

  return (
    <div>
      <Text type="secondary" className="panel-hint">
        {t("warRoom.dataPanel.hintBefore")}
        <Text strong style={{ fontSize: 12 }}>
          {t("warRoom.dataPanel.hintStrong")}
        </Text>
        {t("warRoom.dataPanel.hintAfter")}
      </Text>

      <Input.Search
        allowClear
        size="small"
        placeholder={t("warRoom.dataPanel.search")}
        value={q}
        onChange={(e) => setQ(e.target.value)}
        style={{ marginBottom: 10 }}
      />

      {groups.length === 0 ? (
        <Empty
          image={null}
          description={
            datasets.length === 0
              ? t("warRoom.dataPanel.noAccess")
              : t("warRoom.dataPanel.noMatch")
          }
        />
      ) : null}

      {groups.map(({ group, items }) => (
        <div key={group} className="pick-group">
          <Text className="pick-group__title">
            {t(`warRoom.groups.${group}`)}
          </Text>
          {items.map((d) => (
            <Tooltip key={d.key} placement="left" title={d.description}>
              <button
                type="button"
                onClick={() => pickDataset(d.key)}
                className={`pick-row${activeDatasetKey === d.key ? " is-active" : ""}`}
              >
                <span className="pick-row__label">{d.label}</span>
                {activeDatasetKey === d.key ? <CheckOutlined /> : null}
              </button>
            </Tooltip>
          ))}
        </div>
      ))}
    </div>
  );
}
